// Generated by ReScript, PLEASE EDIT WITH CARE


var promo_download_heading = "Love what you see? ❤️";

var form_invalid_pickup_location = "Select a valid address";

var form_invalid_dropoff_location = "Select a valid address";

var form_no_pickup_location = "Enter the pickup address";

var form_no_dropoff_location = "Enter the dropoff address";

var form_invalid_category = "Invalid Porter Service Selected";

var pickup_address_placeholder = "Enter pickup address";

var drop_address_placeholder = "Enter drop address";

var call_back_req = "Request a callback >";

var call_back_desc = "Callback request saved successfully";

var promo_download_scan_to_download = "Scan to download our app!";

var promo_download_sms_to_download = "Or **click here to receive a download link via SMS**";

var promo_explore_section_title = "Other Services in your area";

var error_default_text = "We do not provide service from this location yet!";

var service_category_pnm = "pnm";

var service_category_trucks = "trucks";

var service_category_two_wheelers = "2 wheeler";

var service_category_courier = "courier";

var page_title_trucks = "Trucks";

var page_title_two_wheelers = "Two Wheelers";

var page_title_pnm = "Packers & Movers";

var page_title_pnm_v2 = "Packers and Movers";

var page_title_courier = "Intercity Courier Service";

var page_title_partload = "Partload";

var page_title_canter_3_tonne = "Canter 3 Tonne";

var page_title_pickup_1_tonne = "Pickup 1 Tonne";

var page_title_one_ton_7_feet = "One Ton 7 Feet";

var page_title_compact = "Compact";

var ga_button_sticky_download_app = "Sticky - Fare Estimate";

var ga_button_request_callback = "Request Callback /<Click>";

var ga_event_pickup_field_edit = "Pickup Address Input Field Edit";

var ga_event_dropoff_field_edit = "Dropoff Address Input Field Edit";

var ga_event_explore_other_services = " Banner Click - Fare Estimate Page";

var ga_event_trucks = "trucks";

var ga_event_2w = "2w";

var ga_event_pnm = "pnm";

var default_trucks_image = {
  path: "/images/fare-estimate-result/default-truck-icon.svg",
  alt_text: "Truck Icon"
};

var retry_button_text = "Retry";

var fare_estimate_title = "India's largest mini truck aggregator | Tata Ace for Rent";

var fare_estimate_description = "Looking to hire a mini truck? Use the Porter App. Get tata ace at doorstep in 30 mins. Faster, economical, hassle-free mini truck booking. Choose from over 3000 trained drivers & a wide range of dedicated vehicles.";

var brand_label = "porter";

var source_website_label = "website";

var recaptcha_init_delay = 500;

export {
  form_invalid_pickup_location ,
  form_invalid_dropoff_location ,
  form_no_pickup_location ,
  form_no_dropoff_location ,
  form_invalid_category ,
  pickup_address_placeholder ,
  drop_address_placeholder ,
  call_back_req ,
  call_back_desc ,
  promo_download_heading ,
  promo_download_scan_to_download ,
  promo_download_sms_to_download ,
  promo_explore_section_title ,
  error_default_text ,
  service_category_pnm ,
  service_category_trucks ,
  service_category_two_wheelers ,
  service_category_courier ,
  page_title_trucks ,
  page_title_two_wheelers ,
  page_title_pnm ,
  page_title_pnm_v2 ,
  page_title_courier ,
  page_title_partload ,
  page_title_canter_3_tonne ,
  page_title_pickup_1_tonne ,
  page_title_one_ton_7_feet ,
  page_title_compact ,
  ga_button_sticky_download_app ,
  ga_button_request_callback ,
  ga_event_pickup_field_edit ,
  ga_event_dropoff_field_edit ,
  ga_event_explore_other_services ,
  ga_event_trucks ,
  ga_event_2w ,
  ga_event_pnm ,
  default_trucks_image ,
  retry_button_text ,
  fare_estimate_title ,
  fare_estimate_description ,
  brand_label ,
  source_website_label ,
  recaptcha_init_delay ,
}
/* No side effect */
